var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"outline-secondary"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('download_excel_template')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }